import _default from './Dimmer';
export { _default as default };